import API from "./AxiosInstance";

export const apiRequest = async (method, url, data = null) => {
  try {
    const isFormData = data instanceof FormData;

    const config = {
      method,
      url,
      headers: {},
    };
    
    if (!isFormData && data !== null) {
      config.headers["Content-Type"] = "application/json";
      config.data = JSON.stringify(data);
    } else if (isFormData) {
      config.data = data;
    }

    const res = await API.request(config);
    return res.data;
  } catch (error) {
    throw error;
  }
};

